import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box
} from '@mui/material';
import { Language } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSelector = () => {
  const theme = useTheme();
  const { language, changeLanguage, availableLanguages } = useLanguage();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    handleClose();
  };

  const currentLang = availableLanguages.find(lang => lang.code === language);

  return (
    <>
      <IconButton
        onClick={handleClick}
        color="inherit"
        title="Change Language"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2">
            {currentLang?.flag}
          </Typography>
          <Language />
        </Box>
      </IconButton>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: theme.direction === 'rtl' ? 'left' : 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: theme.direction === 'rtl' ? 'left' : 'right',
        }}
      >
        {availableLanguages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={lang.code === language}
          >
            <ListItemIcon>
              <Typography variant="h6">{lang.flag}</Typography>
            </ListItemIcon>
            <ListItemText primary={lang.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
